{
  "client": "Client",
  "production": "Production",
  "deadline": "Deadline",
  "agency": "Agence",
  "Current_task": "Tache actuelle",
  "project_progress": "Etat du projet",
  "project_deadline": "Deadline du projet",
  "current_task": "Tache actuelle",
  "Task": "Tache",
  "review_now": "Revoir",
  "1_development": "1. Développemen",
  "2_pre_production": "2. Pre-production",
  "3_production": "3. Production",
  "4_post_production": "4. Post-production",
  "5_delivery": "5. Livraison",
  "task_completed": "tache(s) accomplie(s)",
  "development_progress": "Progression:",
  "add_file": "Ajouter un fichier",
  "idea": "Idée",
  "deadline_step": "Deadline",
  "documents": "Documents",
  "document": "Document",
  "comments": "Commentaires",
  "comment": "Commentaire",
  "producer": "Producteur",
  "producers": "Producteurs",
  "budget": "Budget",
  "director": "Directeur",
  "directors": "Directeurs",
  "add_director": "Ajouter directeur",
  "add_producer": "Ajouter producteur",
  "add_moodboard": "Ajouter moodboard",
  "moodboard": "Moodboard",
  "moodboards": "Moodboards",
  "quotes": "Quotes",
  "quote": "Quote",
  "script": "Scripte",
  "scripts": "Scriptes",
  "files": "Fichiers",
  "storyboard": "Storyboard",
  "add_shot": "Ajouter shot",
  "add_contract": "Ajouter Contract",
  "contract": "Contract",
  "contracts": "Contracts",
  "accepted": "Fichiers acceptés",
  "drag": "Drag and Drop ici",
  "or": "ou",
  "browse_files": "Chercher un fichier",
  "download_contract": "Télécharger contract",
  "sign_and_upload": "Signer et uploader",
  "signed_by_producer": "Signé par le producteur",
  "unsigned": "non-signé",
  "waiting_client_sign": "Signé par le produceur, en attente du client",
  "signed_by_both_parties": "Signé par les deux",
  "signature_pending": "En attente de signature",
  "signed": "Signé",
  "waiting": "En attente de la signaure du client",
  "waiting_client": "Quand les deux parties auront signé le fichier, ce dernier se trouvera dans la section ci-dessous",
  "send_to_client": "Envoyer au client pour signature",
  "send_contract": "Envoyer le contract",
  "waiting_payment": "En attente du payement du client",

  "first_payment": "Premier payement",
  "add_invoice": "Ajouter invoice",
  "payment_pending": "Payement en attente",
  "paid": "Payé",
  "unpaid": "non payé",
  "waiting_client_payment": "En attente du payement du client",
  "crew": "Equipe",
  "add_crew": "Ajouter une personne",
  "role": "Role",
  "roles": "Roles",
  "all_scenes": "Toutes les scènes",
  "all": "Tous afficher",

  "person": "Personne",
  "people": "Personnes",
  "cast_preselection": "Cast pré-selection",
  "preselection": "Pré-selection du cast",
  "add_talent": "Ajouter talent",
  "add_location": "Ajouter location",
  "location": "Locations",
  "locations": "Location",
  "contact": "Contact",
  "requirements": "Requirements",
  "nearest_parking": "Parking le plus proche",
  "nearest_hospital": "Hopital le plus proche",
  "shot_list": "Shot list",
  "shooting_day": "Jour de shoot",
  "shooting_days": "Jours de shoot",
  "ppm": "PPM",
  "add_shooting_day": "Ajouter jour de shoot",
  "date": "Date",
  "note": "Note",
  "table": "Table",
  "gear": "Equipement",
  "gears": "Equipements",
  "equipment": "Equipment",
  "qty": "qty",
  "rate_day": "prix/day",
  "rate_week": "prix/week",
  "rent_period": "Période de location",
  "subtotal": "Sous-total",
  "pick_up": "pick up",
  "add_gear": "Ajouter equipement",
  "callsheet": "Callsheet",
  "callsheets": "Callsheets",
  "generate_callsheet": "Générer callsheet",
  "second_payment": "Second payement",
  "invoice_second_payment": "invoice",
  "shots": "Shots",
  "directors_note": "Note du directeur",
  "rushes": "Rushes",
  "add_video": "Ajouter video",
  "return_gear": "Equipements rendus",
  "editing": "Editing",
  "prepare_edit": "Editing en préparation",
  "work_in_progress": "Edit in progress",
  "come_back": "Revenez dans quelques jours",
  "selected": "selectonés",
  "on": "sur",
  "no_color_grading": "pas de couleur grading",
  "no_motion_graphic": "pas de motion graphic",
  "no_sound_design": "pas de sound design",
  "start_video_call": "Commencer une conférence",
  "first_rough_cut": "Première ébauche",
  "video": "Vidéo",
  "motion_design": "Motion design",
  "first_correction": "Première correction",
  "second_correction": "Seconde correction",
  "picture_lock": "Picture lock",
  "final_sound": "Final sound",
  "color_grading": "Color grading",
  "final_film": "Film final",
  "add_scene": "Ajouter une scène",
  "add_team": "Ajouter une team",
  "add_rush": "Ajouter un rush",
  "add_new_folder": "Ajouter un dossier",
  "add_folder": "Ajouter un dossier",
  "all_files": "Tous les fichiers",
  "no cover": "Pas d'image de couverture",
  "delete_scene": "Etes-vous sure de vouloir supprimer cetee scene ?",
  "language": "fr",
  "open_on_tab": "Ouvrir dans un onglet"
}
